import QuestionPage from '@app-studio-web/ui/pages/QuestionPage'
import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useSubmit } from 'react-router-dom'
import useUpdateMode from '../../hooks/useUpdateMode'
import { saveAnswer } from '../../utils/onboardingStorage'

const QUESTION_KEY = 'habits'

export default function HabitsPage() {
  const submit = useSubmit()
  const { t } = useTranslation()
  const { isUpdate, postToReactNative } = useUpdateMode()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    // Get the answer value from the form
    const formData = new FormData(event.currentTarget)
    const selectedValue = formData.get('answer') as string

    if (!selectedValue) return

    const answer = {
      question_key: QUESTION_KEY,
      question: t('pages.onboarding.habits.heading', { lng: 'en' }),
      answer_key: selectedValue,
      answer: selectedValue,
    }

    if (isUpdate) {
      postToReactNative(answer)
    } else {
      saveAnswer(QUESTION_KEY, answer)
      submit(event.currentTarget)
    }
  }

  // Habits options
  const getHabitsOptions = () => [
    {
      value: 'Caffeine too late',
      translationKey: 'pages.onboarding.habits.options.caffeine',
      emoji: '☕',
    },
    {
      value: 'Screen time before bed',
      translationKey: 'pages.onboarding.habits.options.screenTime',
      emoji: '📱',
    },
    {
      value: 'Irregular sleep schedule',
      translationKey: 'pages.onboarding.habits.options.irregularSchedule',
      emoji: '⏰',
    },
    {
      value: 'Alcohol at night',
      translationKey: 'pages.onboarding.habits.options.alcohol',
      emoji: '🍷',
    },
    {
      value: 'No bedtime routine',
      translationKey: 'pages.onboarding.habits.options.noBedtimeRoutine',
      emoji: '💤',
    },
  ]

  // Get the options
  const options = getHabitsOptions()

  // Transform options to the format expected by QuestionPage
  const buttons = options.map((option) => ({
    text: `${option.emoji} ${t(option.translationKey)}`,
    value: option.value,
  }))

  useEffect(() => {
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(
        JSON.stringify({ type: 'REQUEST_ATT' }),
      )
    }
  }, [])

  return (
    <QuestionPage
      heading={t('pages.onboarding.habits.heading')}
      buttons={buttons}
      onSubmit={handleSubmit}
      headingSize="text-3xl text-center whitespace-pre-line"
      buttonTextSize="text-xl"
      buttonBgColor="bg-white"
    />
  )
}
